import { Injectable, WritableSignal, signal } from '@angular/core';
import {
  DynamicPricingOptionsResponse,
  DynamicPricingPreview,
} from '@app/shared/interfaces/lib/dynamic-pricing.interface';
import { LoadingState } from '@ui';

export type StateKey = keyof PropertyState;

export interface PropertyState {
  config: DynamicPricingOptionsResponse | null;
  configLoading: LoadingState;
  previewVisible: boolean;
  previewLoading: boolean;
  dynamicPricingPusherUpdates: boolean;
  dynamicPriceMap: DynamicPricingPreview | null;
}

export function createInitialPropertyState(): PropertyState {
  return {
    config: null,
    configLoading: LoadingState.NotSent,
    previewVisible: false,
    previewLoading: false,
    dynamicPricingPusherUpdates: false,
    dynamicPriceMap: null,
  };
}

@Injectable({
  providedIn: 'root',
})
export class DynamicPricingStore {
  private propertyStates = new Map<number, WritableSignal<PropertyState>>();

  public getPropertyState(propertyId: number): WritableSignal<PropertyState> {
    return this.propertyStates.get(propertyId) ?? this.createPropertyState(propertyId);
  }

  private createPropertyState(propertyId: number) {
    const initialState = createInitialPropertyState();
    const stateSignal = signal(initialState);
    this.propertyStates.set(propertyId, stateSignal);
    return stateSignal;
  }

  public updateState(propertyId: number, key: StateKey, value: unknown) {
    const state = this.getPropertyState(propertyId);
    state.update((s) => ({ ...s, [key]: value }));
  }

  public removeProperty(propertyId: number) {
    this.propertyStates.delete(propertyId);
  }
}
